import * as React from "react";
const SvgEqualizer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.5 18V16H21.5V18H9.5ZM9.5 13V11H21.5V13H9.5ZM3.5 8V6H21.5V8H3.5Z", fill: "white" }));
export default SvgEqualizer;
